import { render, staticRenderFns } from "./compcheck.vue?vue&type=template&id=6ec55975"
import script from "./compcheck.vue?vue&type=script&lang=js"
export * from "./compcheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports